// extracted by mini-css-extract-plugin
module.exports = {"layerContainer":"SpinnerButton_layerContainer__1Aqv5","layer":"SpinnerButton_layer__1DwNv"};